import { IonContent, IonInput, IonPage, IonText,IonIcon,IonSpinner } from "@ionic/react";
import { useEffect, useState,useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router";
import DataTable from "react-data-table-component";
import service from "../../../Service/service";
import Head from "../../Header";
import Sidebar from "../../Sidebar";
import moment from "moment";

const PendingCompoff: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
          history.push("/login");
        } else {
        }
      }, [Id, history]);
    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");

    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [employeelist, setEmployeelist] = useState([]);
    const [loading,setloading]=useState(false)
    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);
    const [status,setstatus]=useState('')

    useEffect(() => {
        CompoffApp();
        
    }, []);

    const back = () => {
        history.goBack();
    }
    const CompoffApp = () => {
        setloading(true);
        service.Compoffdashboard(Id)
            .then((response) => {
                console.log(response, "data");
                if (response.status === 200) {
                    setData(response.data);
                    setstatus(response.data.compOffStatus.status)
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
               
                setTimeout(() => {
                    setloading(false); 
                }, 1000); 
            });
    };
    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "100px",
        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.name,
            sortable: true,
            sort: "name",
            width: "280px",
            cell: (itm: any) => (
                <>
                    <div className="wrapper_cls">{itm.employeeDetails.name}{" ("}{itm.employeeDetails.employeeCode}{")"}</div>
                </>
            )
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.employeeDetails.businessUnit.businessUnitName,
            sortable: true,
            width: "180px",
        },
        {
            name: "Department Unit",
            selector: (itm: any) => itm.employeeDetails.masterDepartment.departmentName,
            sortable: true,
            width: "200px",
        },
      
        {
            name: "Worked-Date",
            cell: (itm: any) => itm.workedOnDate ? moment(itm.workedOnDate).format("DD-MM-YYYY") : "NA",
            sortable: true,
        },
        {
            name: "Compoff-Date",
            cell: (itm: any) => itm.compOffDate ? moment(itm.compOffDate).format("DD-MM-YYYY") : "NA",
            sortable: true,
        },        
        {
            name: "Status",
            selector: (itm: any) => itm.compOffStatus.status,
            sortable: true,
            cell: (itm: any) => {
                const status = itm.compOffStatus.status;
                let color;
                if (status === "Registered") {
                    color = "orange";
                } else if (status === "Pending") {
                    color = "red";
                } else {
                    color = "black";
                }
        
                return <span style={{ color }}>{status}</span>;
            },
        }
    ]

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        
        };
    
    
    return (
        <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
                <div className="form-group form-focus row">
                    <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                        value={filterText} placeholder="Search" />
                    <label className="focus-label">Search</label>
                </div>
                <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
            </div>
        </div>
    )
    
    }, [filterText, resetPaginationToggle]);

  
    return (
        <IonPage>
        <Head />
            <Sidebar />
            
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="page-title"> <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "2px" }} /> Dashboard </h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item active">Pending Comp-off</li>
                                </ul>
                            </div>
                        </div>
                        {loading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div >
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                   
                </div>
            </IonContent>
        </IonPage>
    )
}

export default PendingCompoff;